<template>
  <div class="routeMonitor">
    <RouteMonitorNav></RouteMonitorNav>
    <div style="height: 100%">
      <router-view />
    </div>
    <information-footer :image-src="imgUrl" image-height="20px" image-width="auto" :email="email" :hrefList="hrefList" />
  </div>
</template>

<script>
import imgUrl from '@/assets/images/Dragonlab_FlowWatch-white.svg'
// import Foot from '@/submodules/components/Footer'
import RouteMonitorNav from '@/components/layout/RouteMonitorNav'
// import { getGlobalKV } from '@/api/ConsulApi'
export default {
  name: 'Home',
  components: {
    // Foot,
    RouteMonitorNav,
  },
  created() {
    // getGlobalKV('/v1/kv/Global/Email?dc=dc1').then(res => {
    //   this.email = res.data
    // })
    // getGlobalKV('/v1/kv/Global/Footer?dc=dc1').then(res => {
    //   this.hrefList = JSON.parse(String(res.data))
    // })
  },
  data() {
    return {
      imgUrl,
      email: 'sec@cgtf.net',
      hrefList: [
        {
          name: 'CGTF',
          href: 'https://www.cgtf.net/#/',
        },
        {
          name: 'BGPer',
          href: 'https://www.bgper.net/',
        },
        {
          name: 'CGTF RIS',
          href: 'https://bgp.cgtf.net/',
        },
        {
          name: 'Looking Glass',
          href: 'http://lg.cgtf.net',
        },
        {
          name: 'Gperf',
          href: 'http://gperf.cgtf.net/',
        },
        {
          name: 'Flow Watch',
          href: 'https://flowwatch.cgtf.net/',
        },
        {
          name: 'BGP Watch',
          href: 'https://bgpwatch.cgtf.net/',
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.routeMonitor {
  background-image: linear-gradient(45deg, #efbdfa, #cbe3fd, #f9d9d9);
}
</style>
